import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "../lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  // undefined = checking, null = anonymous, object = signed-in
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    let cancelled = false;
    api.get("/auth/me")
      .then((r) => { if (!cancelled) setUser(r.data); })
      .catch(() => { if (!cancelled) setUser(null); });
    return () => { cancelled = true; };
  }, []);

  const login = useCallback(async (identifier, password) => {
    const r = await api.post("/auth/login", { identifier, password });
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const refreshMe = useCallback(async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    return r.data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (err) {
      // Cookie may already be expired; clear local state regardless.
      // eslint-disable-next-line no-console
      console.warn("Logout request failed (session cleared anyway):", err?.message);
    }
    setUser(null);
  }, []);

  const value = useMemo(
    () => ({ user, login, logout, refreshMe, loading: user === undefined }),
    [user, login, logout, refreshMe]
  );

  return <AuthCtx.Provider value={value}>{children}</AuthCtx.Provider>;
}
